import { render, staticRenderFns } from "./AffiliatesWithTriennial.vue?vue&type=template&id=6d9f511a&"
import script from "./AffiliatesWithTriennial.vue?vue&type=script&lang=js&"
export * from "./AffiliatesWithTriennial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports